// technically we dont support legacy browsers without dialog but it seems we still have a chunk
// of users a couple versions behind in safari so this is left here for now.
export const isDialogSupported = () => typeof window?.HTMLDialogElement === 'function';
